import { Directive, Input, Output, HostListener } from '@angular/core';

@Directive({
  selector: '[eosClipboarder]'
})
export class ClipboarderDirective {

  constructor() { }

  @Input('eosClipboarder') public payload: string;

  @HostListener("click", ["$event"])
  public onClick(event: MouseEvent): void {

    event.preventDefault();
    if (!this.payload) {
      return;
    }

    const listener = (e: ClipboardEvent) => {
      const clipboard = e.clipboardData || window['clipboardData'];
      clipboard.setData("text", this.payload.toString());
      e.preventDefault();
    };

    document.addEventListener("copy", listener, false);
    document.execCommand("copy");
    document.removeEventListener("copy", listener, false);
  }
}
